/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';															
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';

import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import { AdditionalInterestComponent } from "premier-capability-policyjob-react";
import metadata from './MiscellaneousPage.metadata.json5';
import styles from './MiscellaneousPage.module.scss';
import messages from './MiscellaneousPage.messages.js';

import CoveragesPageComponent from "../Coverages/CoveragesPage";
import ProductCoverageSelectionComponent from "../../components/Miscellaneous/ProductCoverageSelection/ProductCoverageSelectionComponent";
import CyberInformationComponent from "../../components/Miscellaneous/CyberInformation/CyberInformationComponent";
import BusinessInformationComponent from "../../components/Miscellaneous/BusinessInformation/BusinessInformationComponent";
import RevenuesComponent from "../../components/Miscellaneous/Revenues/RevenuesComponent";
import ScopeofServicesComponent from "../../components/Miscellaneous/ScopeofServices/ScopeofServicesComponent";
import SubcontractorsComponent from "../../components/Miscellaneous/Subcontractors/SubcontractorsComponent";
import UnderwritingInformationComponent from "../../components/Miscellaneous/UnderwritingInformation/UnderwritingInformationComponent";

function MiscellaneousPage(props) {
    const {
        showConfirm
    } = useModal();

    const { wizardData: submissionVM, updateWizardData, currentStep, history, changeNextSteps, steps } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { updateSubmission, saveAndQuoteSubmissionService } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property') || wizardStep.id.includes('propertyCoverages'))
	const { lineName } = PremierConstants;

    const {
        pageKey
    } = currentStep;

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('ArchitectEngineersPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {
            const {jobType} = submissionVM.value.baseData;

            if (!_.isUndefined(submissionVM.value.lobData.proLine.coverables.miscellanousCoverable.productCoverageSelection.pro7)
                && submissionVM.value.lobData.proLine.coverables.miscellanousCoverable.productCoverageSelection.pro7) {
                if (_.filter(steps, (step) => step.id === 'property').length === 0) {
                    if (jobType === 'PolicyChange') {
                        steps.splice(4, 0, propertySteps[0], propertySteps[1]);
                        changeNextSteps(steps.slice(3, 13))
                    } else {
                        steps.splice(5, 0, propertySteps[0], propertySteps[1]);
                        changeNextSteps(steps.slice(4, 13))
                    }
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id === 'property').length !== 0) {
                    if (jobType === 'PolicyChange') {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(3, 12))
                    } else {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('property')).slice(4, 12))
                    }
                }
            }

            const productCode = _.get(submissionVM.value, 'baseData.productCode');
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = productCode ? lineName[productCode] : '';
            const response = await updateSubmission(lobLineName, 'MiscellaneousPage', submissionVM);

            submissionVM.value = response;

            return submissionVM;
        },
        [submissionVM]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.proLine.coverables.miscellanousCoverable.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';

            await updateSubmission(lobLineName, 'MiscellaneousPage', subVMCopy);
                            
            return submissionVM;
        },
        [submissionVM]
    );

    const overrideProps = {
        productCoverageSelectionComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.productCoverageSelection"
        },
        businessInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.businessInformation"
        },
        revenuesComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.revenues"
        },
        scopeofServicesComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.scopeofServices"
        },
        subcontractorsComponent: {
            visible: !_.isUndefined(submissionVM.lobData.value.proLine.coverables.miscellanousCoverable.productCoverageSelection.doeTheComSubAnyWorTo10) && submissionVM.lobData.value.proLine.coverables.miscellanousCoverable.productCoverageSelection.doeTheComSubAnyWorTo10,
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.subContractors"
        },
        cyberInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.cyberInformation"
        },
        underwritingInformationComponent: {
            submissionVM,
            updateWizardData,
            // eslint-disable-next-line no-secrets/no-secrets
            pathUpdated: "lobData.proLine.coverables.miscellanousCoverable.underwritingInformation"
        },
        pplLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.proLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages'
        },
        pplExclusionCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.proLine.lineCoverages.exclusions`,
            title: messages.formMiscellaneous,
            clasueType: 'exclusions'
        },
        additionalInterest:{
            value: submissionVM,
            path: `lobData.proLine.coverables.additionalInterests`,
            type: 'additionalInterest',
            onValueChange: updateWizardData,
            authHeader
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            businessInformationComponent: BusinessInformationComponent,
            cyberInformationComponent: CyberInformationComponent,
            revenuesComponent: RevenuesComponent,
            scopeofServicesComponent: ScopeofServicesComponent,
            subcontractorsComponent: SubcontractorsComponent,
            productCoverageSelectionComponent: ProductCoverageSelectionComponent,
            underwritingInformationComponent: UnderwritingInformationComponent,
            coveragespagecomponent: CoveragesPageComponent,
            additionalInterestComponent: AdditionalInterestComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.proLine.coverables.miscellanousCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

MiscellaneousPage.propTypes = wizardProps;
export default withRouter(MiscellaneousPage);
